module.exports = "/images/Austria.png?1e77759860490b3002da3ece30b46467";